var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 3.89543 1.89543 3 3 3H21.5C22.6046 3 23.5 3.89543 23.5 5V19C23.5 20.1046 22.6046 21 21.5 21H3C1.89543 21 1 20.1046 1 19V5Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5C9 15.8978 9.15803 16.2794 9.43934 16.5607C9.72064 16.842 10.1022 17 10.5 17C10.8978 17 11.2794 16.842 11.5607 16.5607C11.842 16.2794 12 15.8978 12 15.5C12 15.1022 11.842 14.7206 11.5607 14.4393C11.2794 14.158 10.8978 14 10.5 14C10.1022 14 9.72064 14.158 9.43934 14.4393C9.15803 14.7206 9 15.1022 9 15.5Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15V7L14.7141 9.27566C15.3657 9.82133 15.7957 10.5251 15.9433 11.2871C16.0909 12.0491 15.9486 12.8307 15.5365 13.5211",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFile);
export default __webpack_public_path__ + "static/media/audio-file.5c786be75938e777b5363cba17da954b.svg";
export { ForwardRef as ReactComponent };